(() => {
  const TEXT_SUBSCRIBE = 'Subscribe & save';
  const TEXT_ONETIME = 'One-time purchase';

  function initWrapper(wrapper) {
    const toggle = wrapper.querySelector('[data-skio-toggle-input]');
    const picker = wrapper.querySelector('[data-skio-picker]');
    if (!toggle || !picker) return;

    const tagName = picker.tagName.toLowerCase();
    const key = picker.getAttribute('key') || '';
    const SUB_SELECTED_BG = '#768e75';

    function hideSkioRadioDot(root) {
      if (!root) return;
      if (root.querySelector('#skio-hide-radio-dot')) return;

      const style = document.createElement('style');
      style.id = 'skio-hide-radio-dot';
      style.textContent = `
        .skio-radio__container { display: none !important; }
        .group-content.margin-left { margin-left: 0 !important; }

        /* Hide legend visually but keep it accessible */
        #skio-plan-picker-legend {
          position: absolute !important;
          width: 1px !important;
          height: 1px !important;
          padding: 0 !important;
          margin: -1px !important;
          overflow: hidden !important;
          clip: rect(0, 0, 0, 0) !important;
          white-space: nowrap !important;
          border: 0 !important;
        }

        .skio-details {
        margin-bottom: 0!important;
        }

        skio-plan-picker {
            width: 100%!important;
            max-width: 100%!important;
        }

        .product-form__buttons {
        max-width: 100%;
        }
      `;
      
      root.appendChild(style);
    }

    function syncUiCopy() {
      // Backwards compatible: if the old label exists, keep it working.
      const toggleText = wrapper.querySelector('[data-skio-toggle-text]');
      if (toggleText) {
        toggleText.textContent = toggle.checked ? TEXT_SUBSCRIBE : TEXT_ONETIME;
      }

      // New MASA-style copy blocks
      const subNodes = wrapper.querySelectorAll('[data-skio-state="sub"]');
      const oneNodes = wrapper.querySelectorAll('[data-skio-state="one"]');

      subNodes.forEach((el) => {
        if (toggle.checked) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });

      oneNodes.forEach((el) => {
        if (!toggle.checked) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    }

    function getShadow() {
      return picker.shadowRoot;
    }

    function findOneTimeInput(root) {
      if (!root || !key) return null;
      return root.querySelector(`[id="one-time-${key}"]`);
    }

    function findOneTimeContainer(root) {
      const input = findOneTimeInput(root);
      if (!input) return null;
      return input.closest('.group-container') || null;
    }

    function findFirstSubscriptionGroupInput(root) {
      if (!root) return null;
      return root.querySelector('input.group-input[type="radio"][id^="group-"]');
    }

    function applyState() {
      syncUiCopy();

      const root = getShadow();
      if (!root) return;
      hideSkioRadioDot(root);

      const oneTimeInput = findOneTimeInput(root);
      const oneTimeContainer = findOneTimeContainer(root);

      // Only tint the selected group when Subscribe & Save is ON
      if (toggle.checked) {
        picker.style.setProperty('--skio-group-background-selected-color', SUB_SELECTED_BG);
      } else {
        picker.style.removeProperty('--skio-group-background-selected-color');
      }

      // If one-time isn't available (requires selling plan), hide the toggle UI entirely.
      if (!oneTimeInput || !oneTimeContainer) {
        wrapper.querySelector('[data-skio-purchase-toggle]')?.setAttribute('hidden', '');
        return;
      } else {
        wrapper.querySelector('[data-skio-purchase-toggle]')?.removeAttribute('hidden');
      }

      const allGroupContainers = Array.from(root.querySelectorAll('.group-container'));

      if (toggle.checked) {
        // Subscribe mode: show subscription groups, hide one-time group
        allGroupContainers.forEach((el) => {
          if (el === oneTimeContainer) el.style.display = 'none';
          else el.style.display = '';
        });

        // Also make sure we are not left on one-time
        if (oneTimeInput.checked) {
          const firstSub = findFirstSubscriptionGroupInput(root);
          if (firstSub) firstSub.click();
        }
      } else {
        // One-time mode: show ONLY one-time group, hide subscription groups
        allGroupContainers.forEach((el) => {
          if (el === oneTimeContainer) el.style.display = '';
          else el.style.display = 'none';
        });

        // Select one-time
        if (!oneTimeInput.checked) oneTimeInput.click();
/*
        // Extra cleanup: hide any subscription frequency content that might be visible during transition
        root.querySelectorAll('.group-content').forEach((el) => {
          el.style.display = 'none';
        });*/
      }
    }

    function observeRenders() {
      const root = getShadow();
      if (!root) return;

      const obs = new MutationObserver(() => {
        applyState();
      });

      obs.observe(root, { childList: true, subtree: true });
    }

    toggle.addEventListener('change', applyState);

    customElements.whenDefined(tagName).then(() => {
      requestAnimationFrame(() => {
        applyState();
        hideSkioRadioDot(getShadow());
        observeRenders();

        const form = picker.closest('form');
        if (form) {
          form.addEventListener('change', (e) => {
            const t = e.target;
            if (!t) return;
            if (t.name === 'id' || (t.matches && t.matches('select[name="id"]'))) {
              requestAnimationFrame(applyState);
            }
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-skio-toggle-wrapper]').forEach(initWrapper);
  });
})();